import React, { useCallback, useEffect, useState } from "react";
import { adminApi } from "../services/adminApi";
import usePolling from "../hooks/usePolling";
import Pagination from "../components/Pagination";

export default function DepositManagement() {
  const [filters, setFilters] = useState({ userId: "", from: "", to: "", status: "" });
  const [data, setData] = useState({ items: [], total: 0, page: 1, pageSize: 10 });
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const next = await adminApi.getDeposits({
        page: data.page,
        pageSize: data.pageSize,
        ...filters,
      });
      setData(next);
      setError("");
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to load deposits");
    }
  }, [filters, data.page, data.pageSize]);

  usePolling(load, 20000, [
    filters.userId,
    filters.from,
    filters.to,
    filters.status,
    data.page,
    data.pageSize,
  ]);

  useEffect(() => {
    setData((prev) => (prev.page === 1 ? prev : { ...prev, page: 1 }));
  }, [filters.userId, filters.from, filters.to, filters.status]);

  return (
    <div>
      <h2>Deposit Management</h2>
      <div className="row" style={{ marginBottom: 12 }}>
        <input
          placeholder="User ID"
          value={filters.userId}
          onChange={(e) => setFilters((p) => ({ ...p, userId: e.target.value }))}
        />
        <input type="date" value={filters.from} onChange={(e) => setFilters((p) => ({ ...p, from: e.target.value }))} />
        <input type="date" value={filters.to} onChange={(e) => setFilters((p) => ({ ...p, to: e.target.value }))} />
        <select value={filters.status} onChange={(e) => setFilters((p) => ({ ...p, status: e.target.value }))}>
          <option value="">All Statuses</option>
          <option value="pending">Pending</option>
          <option value="confirmed">Confirmed</option>
        </select>
        <button className="btn-primary" onClick={load}>Refresh</button>
      </div>
      {error ? <div className="error">{error}</div> : null}

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Amount</th>
                <th>Network</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {(data.items || []).map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.wallet?.user?.email || item.wallet?.userId}</td>
                  <td>{item.amount}</td>
                  <td>{item.meta?.network || "-"}</td>
                  <td>{item.meta?.status || "-"}</td>
                  <td>{new Date(item.createdAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          page={data.page}
          pageSize={data.pageSize}
          total={data.total}
          onPageChange={(nextPage) =>
            setData((prev) => ({
              ...prev,
              page: nextPage,
            }))
          }
        />
      </div>
    </div>
  );
}
